import { useEffect, useState, useContext, useRef } from 'react'
import moment from 'moment'

import useStore from '../../store/useStore'

import { Dropdown, MenuProps, Popconfirm, Tooltip } from 'antd'

import { getImgUrlById } from '../../util'
import user_default from '../../static/image/user_default.png'
import { CloseOutlined } from '@ant-design/icons'
// import _ from 'lodash';
import _throttle from 'lodash/throttle';
import _debounce from 'lodash/debounce';
interface Props {
    onClick?: (e?: any) => void;
}
interface State {

}


const SelectedExecutor = (props: Props) => {
    const [state, setState] = useState<State>({
        userInfo: {}

    });
    const [pageType, setPageType] = useState<any>('');
    const { store, dispatch } = useStore();
    const [active, setActive] = useState<any>(null);
    const [storeName, setStoreName] = useState<any>([]);

    useEffect(() => {
        let type: any = window.location.hash.slice(2)
        if (type.indexOf('/') >= 0) {
            type = type.slice(0, type.indexOf('/'))
        }
        setPageType(type)
        if (type === 'gantt') {
            setStoreName(['SET_GANTTEXECUTORROWS', 'SET_GANTTEXECUTOROWKEYS'])
        } else {
            //日历视图
            setStoreName(['SET_CALENDAREXECUTORROWS', 'SET_CALENDAREXECUTOROWKEYS'])

        }
    }, [window.location.hash,])
    const items: MenuProps['items'] = [
        {
            label: '删除',
            key: 'item-1',
        },
    ];
    const onClick: MenuProps['onClick'] = ({ key, domEvent }) => {
        console.log(key)
        switch (key) {
            case 'item-1':
                let newRows: any = store.calendarExecutorRows.filter((i: any) => i.id != active?.id)
                let newRowKeys: any = store.calendarExecutorRowKeys.filter((i: any) => i != active?.id)

                console.log(newRows)
                dispatch({
                    type: storeName[0],
                    data: newRows
                });
                dispatch({
                    type: storeName[1],
                    data: newRowKeys
                });
                break;
        }
    };


    const dealSelect = (i: any) => {
        console.log(i)
        if (i.id === store.calendarExecutor?.id) {
            dispatch({
                type: 'SET_CALENDAREXECUTOR',
                data: null
            });
            props.onClick && props.onClick()
        } else {
            dispatch({
                type: 'SET_CALENDAREXECUTOR',
                data: i
            });
            props.onClick && props.onClick(i)
        }
    }
    // 处理点击事件的回调函数
    const handleClick = (param:any) => {
        // 处理点击事件的逻辑
        console.log('Click with param:', param);
    };
    // 创建防抖函数，可以根据需要调整延迟时间
     const debouncedClick = _debounce(dealSelect, 1000);
    // const debouncedClick = _throttle(handleClick, 5000);

    return (
        <>
            <div data-flex='main:right cross:center'>
                {store.calendarExecutorRows.map((i: any, index: any) => (
                    <Tooltip title={i.username}>
                        <Dropdown overlayClassName='better-z-index' menu={{ items, onClick, }} key={i.id} trigger={['contextMenu']}>
                            <div onMouseEnter={(e) => {
                                e.stopPropagation();
                                setActive(i)
                            }} key={index} className={`mr-5 `} onClick={() => { debouncedClick(i) }}>
                                <img alt="" className={`user_default ${(i.id === store.calendarExecutor?.id) && 'online'}`} src={getImgUrlById(i.avatar)} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                            </div>
                        </Dropdown>
                    </Tooltip>
                ))}
                {store.calendarExecutorRows.length > 0 &&
                    <Popconfirm
                        title="确定重置执行人筛选么？"
                        onConfirm={() => {
                            dispatch({
                                type: storeName[0],
                                data: []
                            });
                            dispatch({
                                type: storeName[1],
                                data: []
                            });
                            // dispatch({
                            //     type: 'SET_CALENDAREXECUTOR',
                            //     data: null
                            // });
                        }}
                        onCancel={() => { }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <CloseOutlined className='icon_hover mr-5' />
                    </Popconfirm>
                }
            </div></>
    )
}

export default SelectedExecutor
